export const determineTotalInvestValue = (investmentTrans, investType, priceArr) => {

    let totalInitialValue = 0;
    let totalCurrentValue = 0;
    for (let i=0; i<investmentTrans.length; i++){
        const shortName = investmentTrans[i].investShortName;
        const currentPriceObj = priceArr.find(elem => elem.investShortName === shortName);
        let tranInitialValue = +investmentTrans[i].unitPrice * +investmentTrans[i].quantity;
        const currentPrice = currentPriceObj.currentPrice;
        let tranCurrentValue = +currentPrice * +investmentTrans[i].quantity;
        if (investmentTrans[i].tranType === "sell"){
            tranInitialValue = -1 * tranInitialValue;
            tranCurrentValue = -1 * tranCurrentValue;
        }
        totalInitialValue += tranInitialValue;
        totalCurrentValue += tranCurrentValue;
    }
    const totalValueObj = {investType: investType, initialValue: totalInitialValue, 
        currentValue: totalCurrentValue};
    return totalValueObj;
}

export default determineTotalInvestValue;